import { useLang } from "../context/LanguageContext";
import { FadeUp, InviewMaskLine } from "../components/Reveal";
import SellForm from "../components/SellForm";

export default function SellYourCar() {
  const { t } = useLang();
  const s = t("sell");

  const scrollForm = (e) => {
    e.preventDefault();
    const el = document.getElementById("sell-form");
    if (!el) return;
    if (window.__lenis) window.__lenis.scrollTo(el, { offset: -80 });
    else el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="bg-[#050607]" data-testid="sell-page">
      <section className="px-5 md:px-10 pt-40 pb-16 md:pt-48 md:pb-20">
        <FadeUp><div className="eyebrow mb-8">{s.eyebrow}</div></FadeUp>
        <h1 className="font-display text-[36px] sm:text-[54px] lg:text-[68px] text-[#F3F3F0] max-w-5xl">
          {s.title.split("\n").map((l, i) => <InviewMaskLine key={i} delay={0.2 + i * 0.14}>{l}</InviewMaskLine>)}
        </h1>
        <FadeUp delay={0.35}><p className="mt-8 text-[15px] text-[#999995] max-w-2xl">{s.sub}</p></FadeUp>
        <FadeUp delay={0.45}><p className="mt-4 text-[13px] text-[#666663] max-w-2xl">{s.support}</p></FadeUp>
        <FadeUp delay={0.55}>
          <a href="#sell-form" onClick={scrollForm} className="btn btn-solid justify-between w-fit mt-10" data-testid="sell-hero-cta">
            <span>{s.submit}</span><span aria-hidden="true">→</span>
          </a>
        </FadeUp>
      </section>

      <section id="sell-form" className="px-5 md:px-10 py-20 md:py-24 border-t border-white/10">
        <div className="max-w-3xl">
          <FadeUp><div className="eyebrow mb-10">{s.formTitle}</div></FadeUp>
          <SellForm />
        </div>
      </section>
    </div>
  );
}
